import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { deleteUser, inviteUser, listUsers, patchUserRole, ROLE_OPTIONS, } from '../api/users';
import { UserIdentityFields } from '../components/UserIdentityFields';
import { SubPageHeader } from '../components/SubPageHeader';
import { roleSelectStyle } from '../utils/roleStyle';
export function AccessPage({ plan }) {
    const { state, handlers, isAdmin } = plan;
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState('');
    const [invEmail, setInvEmail] = useState('');
    const [invFirstName, setInvFirstName] = useState('');
    const [invLastName, setInvLastName] = useState('');
    const [invJobTitle, setInvJobTitle] = useState('');
    const [invAccessLevel, setInvAccessLevel] = useState('reader');
    const [invError, setInvError] = useState('');
    const [inviting, setInviting] = useState(false);
    const reload = useCallback(async () => {
        setLoadError('');
        setLoading(true);
        try {
            const items = await listUsers();
            setMembers(items);
        }
        catch (err) {
            setLoadError(err instanceof Error ? err.message : 'Не удалось загрузить список');
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        reload();
    }, [reload]);
    const handleInvite = async (e) => {
        e.preventDefault();
        if (!isAdmin || inviting)
            return;
        setInvError('');
        const email = invEmail.trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setInvError('Укажите корректный email');
            return;
        }
        setInviting(true);
        try {
            const user = await inviteUser(email, {
                firstName: invFirstName.trim(),
                lastName: invLastName.trim(),
                jobTitle: invJobTitle.trim(),
                role: invAccessLevel,
            });
            setMembers((list) => [user, ...list.filter((m) => m.id !== user.id)]);
            setInvEmail('');
            setInvFirstName('');
            setInvLastName('');
            setInvJobTitle('');
            setInvAccessLevel('reader');
        }
        catch (err) {
            setInvError(err instanceof Error ? err.message : 'Не удалось пригласить');
        }
        finally {
            setInviting(false);
        }
    };
    const handleRoleChange = async (member, role) => {
        if (!isAdmin || member.role === role)
            return;
        try {
            const updated = await patchUserRole(member.id, role);
            setMembers((list) => list.map((m) => (m.id === updated.id ? updated : m)));
        }
        catch (err) {
            setInvError(err instanceof Error ? err.message : 'Не удалось изменить роль');
        }
    };
    const handleRemove = async (member) => {
        if (!isAdmin)
            return;
        try {
            await deleteUser(member.id);
            setMembers((list) => list.filter((m) => m.id !== member.id));
        }
        catch (err) {
            setInvError(err instanceof Error ? err.message : 'Не удалось удалить');
        }
    };
    return (_jsxs("div", { style: { minHeight: '100vh', background: '#F8FAFC', display: 'flex', flexDirection: 'column' }, children: [_jsx(SubPageHeader, { title: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u0430", onGoHome: handlers.goHome, onClose: handlers.closeProfile }), _jsx("div", { style: { flex: 1, display: 'flex', justifyContent: 'center', padding: '32px 24px' }, children: _jsxs("div", { style: { width: 560, maxWidth: '100%', display: 'flex', flexDirection: 'column', gap: 20 }, children: [_jsxs("form", { onSubmit: handleInvite, style: {
                                background: '#FFFFFF',
                                border: '1px solid #E2E8F0',
                                borderRadius: 12,
                                padding: 20,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 10,
                            }, children: [_jsx("div", { style: { fontSize: 14, fontWeight: 700 }, children: "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430" }), _jsx(UserIdentityFields, { email: invEmail, firstName: invFirstName, lastName: invLastName, jobTitle: invJobTitle, accessLevel: invAccessLevel, emailEditable: isAdmin, accessLevelEditable: isAdmin, disabled: !isAdmin, inputHeight: 38, onEmailChange: setInvEmail, onFirstNameChange: setInvFirstName, onLastNameChange: setInvLastName, onJobTitleChange: setInvJobTitle, onAccessLevelChange: setInvAccessLevel }), _jsx("div", { style: { display: 'flex', justifyContent: 'flex-end' }, children: _jsx("button", { type: "submit", disabled: !isAdmin || inviting, className: "kp-login-btn", style: {
                                            height: 38,
                                            padding: '0 20px',
                                            border: 'none',
                                            borderRadius: 8,
                                            background: '#2563EB',
                                            color: '#FFFFFF',
                                            fontSize: 13,
                                            fontWeight: 600,
                                            cursor: isAdmin ? 'pointer' : 'not-allowed',
                                            opacity: !isAdmin || inviting ? 0.6 : 1,
                                        }, children: inviting ? '…' : 'Пригласить' }) }), invError ? _jsx("div", { style: { fontSize: 12, color: '#B91C1C' }, children: invError }) : null, !isAdmin ? (_jsx("div", { style: { fontSize: 12, color: '#64748B' }, children: "\u0418\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u0441\u043E\u0441\u0442\u0430\u0432 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u043C\u043E\u0433\u0443\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u044B." })) : null] }), _jsxs("div", { style: {
                                background: '#FFFFFF',
                                border: '1px solid #E2E8F0',
                                borderRadius: 12,
                                overflow: 'hidden',
                            }, children: [_jsxs("div", { style: {
                                        padding: '14px 20px',
                                        borderBottom: '1px solid #F1F5F9',
                                        display: 'flex',
                                        alignItems: 'baseline',
                                        gap: 8,
                                    }, children: [_jsx("span", { style: { fontSize: 14, fontWeight: 700 }, children: "\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0451\u043D\u043D\u044B\u0435" }), _jsx("span", { style: { fontSize: 12, color: '#94A3B8' }, children: members.length })] }), loadError ? (_jsx("div", { style: { padding: '16px 20px', fontSize: 12, color: '#B91C1C' }, children: loadError })) : loading ? (_jsx("div", { style: { padding: '16px 20px', fontSize: 13, color: '#64748B' }, children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026" })) : (members.map((m) => (_jsxs("div", { style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 12,
                                        padding: '10px 20px',
                                        borderBottom: '1px solid #F8FAFC',
                                    }, children: [_jsxs("div", { style: { flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 2 }, children: [_jsx("div", { style: {
                                                        fontSize: 13,
                                                        color: '#0F172A',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                    }, children: m.fullName }), _jsx("div", { style: {
                                                        fontSize: 11.5,
                                                        color: '#94A3B8',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                    }, children: m.email })] }), _jsx("select", { value: m.role, onChange: (e) => handleRoleChange(m, e.target.value), disabled: !isAdmin, style: roleSelectStyle(m.role, 32, { width: 130, disabled: !isAdmin }), "aria-label": `Уровень доступа ${m.fullName}`, children: ROLE_OPTIONS.map((o) => (_jsx("option", { value: o.value, children: o.label }, o.value))) }), _jsx("button", { type: "button", onClick: () => handleRemove(m), disabled: !isAdmin, title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", style: {
                                                width: 32,
                                                height: 32,
                                                flex: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: 'none',
                                                background: 'none',
                                                borderRadius: 8,
                                                color: isAdmin ? '#94A3B8' : '#CBD5E1',
                                                cursor: isAdmin ? 'pointer' : 'not-allowed',
                                            }, children: _jsxs("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [_jsx("path", { d: "M3 6h18" }), _jsx("path", { d: "M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" }), _jsx("path", { d: "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" }), _jsx("line", { x1: "10", y1: "11", x2: "10", y2: "17" }), _jsx("line", { x1: "14", y1: "11", x2: "14", y2: "17" })] }) })] }, m.id))))] })] }) })] }));
}
